<template>
    <PageLayout :has-buttons="false" :has-title="false" id="Pal_Covt_Pending_container" content-class="p-0">
        <template #content>
            <template v-if="!isLoadError && !isSaveInProgress">
                <TabsLayout
                    :header="`Edit Palliative Patient - ${formatName(
                        patientOptions.data.firstName,
                        patientOptions.data.lastName
                    )}`"
                    :tabs="tabs"
                    :activeTab="activeTab"
                    :handleTabChange="handleTabChange"
                    :showErrors="
                        (tab: any) =>
                            getValidationDetails(tab.name, 'numberOfErrors') > 0 &&
                            getValidationDetails(tab.name, 'isValidated')
                    "
                    :showSuccess="
                        (tab: any) =>
                            getValidationDetails(tab.name, 'numberOfErrors') === 0 &&
                            getValidationDetails(tab.name, 'isValidated')
                    "
                    :numberOfErrors="(tab: any) => getValidationDetails(tab.name, 'numberOfErrors')"
                    :showWarnings="(tab: any) => false"
                >
                    <template #forms>
                        <section
                            :class="`card px-0 material-card mx-3 mb-2 animated ${
                                isNoteIdRequested ? 'faster fadeInDown' : 'slow fadeOutUp'
                            } attach-physician-order`"
                            v-if="isNoteIdRequested"
                        >
                            <section class="card-body p-0">
                                <AttachPhysicianOrder
                                    entity="DME/Supplies"
                                    v-model:order-id="noteId"
                                    :url-note-id="urlNoteId"
                                    :patient-id="patientId"
                                    :open-orders="openOrders"
                                    :close-attach-order="closeUpdateNoteId"
                                    :provider-id="patientOptions.data.providerId"
                                    :application="application"
                                    :account-id="accountId"
                                    :referral-id="patientReferralId"
                                    v-model:is-attach-order-not-required="isAttachOrderNotRequired"
                                >
                                </AttachPhysicianOrder>
                            </section>
                        </section>
                        <section class="container-fluid my-2 flex-grow-1 overflow-auto" v-if="!isFormLoading">
                            <Demographics v-if="activeTab === 1" />
                            <PayerInformation v-if="activeTab === 2" />
                            <ClinicalInformation v-if="activeTab === 3" />
                            <HealthHistory v-if="activeTab === 4" />
                            <Providers v-if="activeTab === 5" />
                            <PharmacyAndDME v-if="activeTab === 6" />
                            <AuthorizedContacts v-if="activeTab === 7" />
                            <EmergencyPreparedness v-if="activeTab === 8" />
                            <AdvanceDirectives v-if="activeTab === 9" />
                            <PatientGoals v-if="activeTab === 10" />
                            <ReferralInformation v-if="activeTab === 11" />
                            <PatientNotes v-if="activeTab === 12" />
                            <MyNotes v-if="activeTab === 13" />
                        </section>
                    </template>

                    <template #buttons v-if="!isLoadError && !isSaveInProgress">
                        <div class="d-flex justify-content-center mt-2 pal-button-container py-2">
                            <button type="button" class="btn btn-outline-primary me-2" @click="cancel()">Cancel</button>
                            <button
                                type="button"
                                class="btn btn-primary me-2"
                                v-if="activeTab !== 1"
                                @click="previous()"
                            >
                                Previous
                            </button>
                            <button type="button" class="btn btn-primary me-2" v-if="activeTab !== 13" @click="next()">
                                Next
                            </button>
                            <button
                                type="button"
                                class="btn btn-primary me-2"
                                v-if="activeTab !== 13 && activeTab !== 7"
                                @click="save(activeTab)"
                            >
                                Save
                            </button>
                            <button type="button" class="btn btn-primary" v-if="activeTab == 13" @click="complete()">
                                Complete
                            </button>
                        </div>
                    </template>
                </TabsLayout>
            </template>
        </template>
    </PageLayout>
</template>

<script lang="ts" src="./ConvertToPendingPal.ts"></script>
<style src="./ConvertToPendingPal.scss"></style>
